import { ChatStore } from "./chat_store_types";

export const selectIsChatMinimized = (id: number | string) => (state: ChatStore) =>
  state.minimizedIds.includes(id);

export const selectIsChatExpanded = (id: number) => (state: ChatStore) => state.expandedId === id;

export const selectIsChatSelected = (id: number) => (state: ChatStore) => state.selectedId === id;

export const selectIsChatListOpen = (state: ChatStore) => !state.minimizedIds.includes("list");
